import React, { useEffect } from 'react'
import {
  useCreateServiceMutation,
  useUpdateServiceMutation
} from '../../redux/apis/servicesManagement/sMServicesApiSlice'
import { useFormik } from 'formik'
import { getUserId } from '../../helpers/auth'
import * as Yup from 'yup'
import { toast } from 'react-toastify'
import { Button, Input, Modal, Select } from 'antd'
import Loader from '../../pages/pages/loader'
import ServiceCategoriesDropdown from '../ServiceCategoriesDropdown'

const EditCreateService = ({ state, open, setOpen, record }) => {
  const [
    updateService,
    { isLoading: isUpdating, isSuccess: SuccessUpdate, error: errorUpdate }
  ] = useUpdateServiceMutation()
  const [
    addService,
    { isLoading: isAdding, isSuccess: SuccessAdd, error: errorAdd }
  ] = useCreateServiceMutation()

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      service_name: record?.service_name || '',
      service_alias: record?.service_alias || '',
      service_type: record?.service_type || '',
      description: record?.description || '',
      service_category: record?.service_category?.id || '',
      sub_category: record?.sub_category || '',
      is_active: state === "edit"?record?.is_active:true,
      to_crawl: state === "edit"?record?.to_crawl:false,
      last_updated_by: getUserId()
    },

    validationSchema: Yup.object({
      service_name: Yup.string().required('Please Enter Service Name'),
      service_type: Yup.string().required('Please Enter Service Type'),
      description: Yup.string().required('Please Enter Service Description'),
      service_category: Yup.number().required('Please Choose Service Category'),
      is_active: Yup.string().required('Please Choose Service Category')
    }),

    onSubmit: async values => {
      const formData = new FormData()
      for (let key in values) {
        formData.append(key, values[key])
      }

      try {
        if (state === 'edit') {
          await updateService({
            body: formData,
            id: record?.id
          }).unwrap()
        } else if (state === 'create') {
          await addService(formData).unwrap()
        }
      } catch (err) {
        console.error(err)
      }
    }
  })

  useEffect(() => {
    if (errorAdd?.data) {
      const errorMessages = Object.values(errorAdd.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    } else if (errorUpdate?.data) {
      const errorMessages = Object.values(errorUpdate.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [errorAdd, errorUpdate])

  useEffect(() => {
    console.log(SuccessAdd, SuccessUpdate)
    if (SuccessAdd && state === 'create') {
      toast.success('Service created successfully!')
      setOpen(false)
    } else if (SuccessUpdate && state === 'edit') {
      toast.success('Service updated successfully!')
      setOpen(false)
    }
  }, [state, SuccessAdd, SuccessUpdate])
  return (
    <Modal
      className='customModal'
      open={open}
      title={state === 'edit' ? `Edit Service` : 'Create Service'}
      onCancel={() => setOpen(false)}
      footer={[
        <Button key='back' onClick={() => setOpen(false)}>
          Cancel
        </Button>,
        <Button
          key='submit'
          type='primary'
          onClick={() => {
            if (Object.keys(validation.errors).length !== 0) {
              Object.keys(validation.errors).map(key => {
                toast.error(validation.errors[key])
              })
              return
            }
            validation.handleSubmit()
          }}
        >
          Submit
        </Button>
      ]}
    >
      <Loader isLoading={isAdding || isUpdating} />

      <div className=' mb-3'>
        <label className="form-label">Service Name</label>
        <Input
          type='text'
          name='service_name'
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.service_name}
        />
        {validation.touched.service_name && validation.errors.service_name ? (
          <p className='text-danger'>{validation.errors.service_name}</p>
        ) : null}
      </div>
      <div className=' mb-3'>
        <label className="form-label">Service Alias</label>
        <Input
          type='text'
          name='service_alias'
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.service_alias}
        />
      </div>
      <div className='mb-3'>
        <label className="form-label">Service Type</label>
        <br />
        <Select
          name='service_type'
          style={{
            width: '100%'
          }}
          onBlur={validation.handleBlur}
          onChange={e => {
            validation.setFieldValue('service_type', e)
          }}
          value={validation.values?.service_type}
          options={[
            { label: 'Customer', value: 'customer' },
            { label: 'Campaign', value: 'campaign' }
          ]}
        />
      </div>
      {validation.touched.service_type && validation.errors.service_type ? (
        <p className='text-danger'>{validation.errors.service_type}</p>
      ) : null}
      <div className=' mb-3'>
        <label className="form-label">Description</label>
        <Input
          type='text'
          name='description'
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.description}
        />
        {validation.touched.description && validation.errors.description ? (
          <p className='text-danger'>{validation.errors.description}</p>
        ) : null}
      </div>
      <div className=' mb-3'>
        <ServiceCategoriesDropdown
          onChange={e => validation.setFieldValue('service_category', e)}
          onBlur={validation.handleBlur}
          value={validation.values.service_category}
          validation={validation}
        />
        {validation.touched.service_category && validation.errors.service_category ? (
          <p className='text-danger'>{validation.errors.service_category}</p>
        ) : null}
      </div>
      <div className='mb-3'>
        <label className="form-label">Sub Category</label>
        <br />
        <Select
          name='sub_category'
          style={{
            width: '100%'
          }}
          onBlur={validation.handleBlur}
          onChange={e => {
            validation.setFieldValue('sub_category', e)
          }}
          value={validation.values?.sub_category}
          options={[
            { label: 'Tube', value: 'tube' },
            { label: 'Search', value: 'search' }
          ]}
        />
        {validation.touched.sub_category && validation.errors.sub_category ? (
          <p className='text-danger'>{validation.errors.sub_category}</p>
        ) : null}
      </div>
      <div className='mb-3'>
        <label className="form-label">Status</label>
        <br />
        <Select
          name='is_active'
          style={{
            width: '100%'
          }}
          onBlur={validation.handleBlur}
          onChange={e => {
            validation.setFieldValue('is_active', e)
          }}
          value={validation.values?.is_active}
          options={[
            { label: 'Active', value: true },
            { label: 'InActive', value: false }
          ]}
        />
      </div>
      {validation.touched.is_active && validation.errors.is_active ? (
        <p className='text-danger'>{validation.errors.is_active}</p>
      ) : null}
      <div className='mb-3'>
        <label className="form-label">To Crawl</label>
        <br />
        <Select
          name='to_crawl'
          style={{
            width: '100%'
          }}
          onBlur={validation.handleBlur}
          onChange={e => {
            validation.setFieldValue('to_crawl', e)
          }}
          value={validation.values?.to_crawl}
          options={[
            { label: 'True', value: true },
            { label: 'False', value: false }
          ]}
        />
      </div>
    </Modal>
  )
}

export default EditCreateService
